import * as React from 'react';
import { get } from 'lodash';
import { MixedContext } from '../contexts';

/**
 * @deprecated prefer using type-safe props from other contexts. This one is for testing purposes only.
 */
export default function useMixedContextValue(key) {
  const context = React.useContext(MixedContext);
  if (!context) {
    throw new Error('"useMixedContext" must be used within a MixedContext');
  }
  return get(context.mixed, key);
}